import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const SaveCommunicationLog = async (payload) => {
  if (!payload) {
    return { isError: true, message: "Communication data required." };
  }

  const accessToken = getToken();
  try {
    const response = await fetch(`${dev_baseUrl}/CommunicationLog/saveCommunicationLog`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // Include the token in the Authorization header
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json();
    console.log(data)

    if (!response.ok || data.isError) {
      return { isError: true, message: data.message || "Failed to log communication." };
    }

    return data;
  } catch (error) {
    console.error("Failed to log communication:", error);
    return { isError: true, message: "An error occurred. Please try again later." };
  }
};